<matchmaking-form-content [contentImage]="content().mappedImage">
  <matchmaking-form-option-list>
    <h2 class="sir-text-style-paragraph-l-bold" data-cy="header-section-1">
      {{ translations()!.projectPage.mainGoalSection }}
    </h2>
    <div class="options-container grid-column">
      @for (option of investmentGoals; track option) {
        <matchmaking-form-option
          [option]="option"
          [isSelected]="optionIsSelected(option, dataService.config()?.projectGoal ?? undefined)"
          (setSelected)="setSelected($event)"
          data-cy="main-goal-option">
        </matchmaking-form-option>
      }
    </div>

    <h2 class="sir-text-style-paragraph-l-bold" data-cy="header-section-2">
      {{ translations()!.projectPage.investmentSection }}
    </h2>
    <div class="options-container grid-column">
      @for (option of investmentLevels; track option) {
        <matchmaking-form-option
          [option]="option"
          [isSelected]="optionIsSelected(option, dataService.config()?.budgetRange ?? undefined)"
          (setSelected)="setSelectedInvestment($event)"
          data-cy="investment-option">
        </matchmaking-form-option>
      }

      @if (initialLoadHadFinished()) {
        <div class="checkbox-container">
          <!--TODO Added ngIf for the checkbox to work. Related to comments in ts file-->
          <sirius-checkbox
            [label]="translations()!.projectPage.checkboxInvestmentSection"
            [formControl]="investmentCheckboxControl"
            [checked]="dataService.config()?.decisionMaker ?? false"
            (change)="handleCheckboxChange($event)"
            id="investmentResponsible"
            name="investmentResponsible"
            data-cy="investment-checkbox">
          </sirius-checkbox>
        </div>
      }
    </div>

    <h2 class="sir-text-style-paragraph-l-bold" data-cy="header-section-3">
      {{ translations()!.projectPage.timelineSection }}
    </h2>
    <div class="options-container">
      @for (option of investmentTimeline; track option) {
        <matchmaking-form-option
          [option]="option"
          [isSelected]="optionIsSelected(option, dataService.config()?.timeline ?? undefined)"
          (setSelected)="setSelectedTimeline($event)"
          data-cy="timeline-option">
        </matchmaking-form-option>
      }
    </div>

    <div class="buttons-container">
      <matchmaking-form-back-button
        [text]="translations()!.button.back"
        (click)="handleBack()"
        data-cy="back-button">
      </matchmaking-form-back-button>
      <matchmaking-form-submit-button
        data-cy="submit-button"
        [text]="translations()!.button.solutionPreview"
        [isDisabled]="isSubmitDisabled()"
        (triggerSubmitEvent)="submit()">
      </matchmaking-form-submit-button>
    </div>
  </matchmaking-form-option-list>
</matchmaking-form-content>
